import CartItemView from 'cart-item.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPerformance, IZone } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state';
import { disablePerformanceButtons, removeItemFromCart, removeSelectedZone, toggleAlternateRequestType } from '../../redux-state/actions/package-listing.actions';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { flatMap } from 'lodash';
import { getCartItemDetails } from '../../helpers/cart-helpers';
import { IPerformanceErrorMessage, ISfoCartItem } from '../../../package-listing/classes/package-listing';


interface ICartItemExternalProps {
    cartItem: ISfoCartItem;
    hideSeatMap: boolean;
    showSeatMapOnly?: boolean;
    showTitleAndRemoveButton?: boolean;
    showAlternateReservationCheckbox?: boolean;
    showAlternateChoiceSection?: boolean;
}

interface StateToProps {
    text: IPackageListingAppText;
    itemProcessErrorMessage: string;
    selectedZone: IZone;
    selectedSecondZone: IZone;
    isUnseated: boolean;
    itemIdToRemove: number;
    itemTitle: string;
    alternateItemTitle: string;
    itemSeason: string;
    itemFacility: string;
    itemDateString: string;
    itemTimeString: string;
    isFixedPackage: boolean;
    showRemoveButton: boolean;
    selectSecondZoneMessageString: string;
    disableAllSeries: boolean;
}

interface DispatchToProps {
    removeItem: (itemId: number, isAlternate?: boolean) => void;
    removeZone: (itemId: number) => void;
    toggleAlternateRequestType: (itemId: number) => void;
    disablePerfButtons: (isDisabled?: boolean) => void;
}

export type CartItemProps = ICartItemExternalProps & StateToProps & DispatchToProps;

export type CombineCartViewProps = CartItemProps;

export class FiltersBase extends React.Component<CartItemProps, any> {
    constructor(props: CartItemProps) {
        super(props);
    }

    render() {
        return <CartItemView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, { cartItem }: ICartItemExternalProps): StateToProps {
    const { cartItemId, selectedZoneId, selectedAlternateItem } = cartItem;
    const perfMessage: Array<IPerformanceErrorMessage> = (state.packageListing.errorMessages != undefined)
        ? state.packageListing.errorMessages.filter(err => err.performanceId === cartItemId)
        : [];

    let performancePricing = state.packageListing.performancePricingList.get(cartItemId);

    const itemDetails = getCartItemDetails(state, cartItemId);
    const alternateItemDetails = getCartItemDetails(state, cartItem.selectedAlternateItem?.cartItemId ?? 0);
    const alternateItemZoneId = selectedAlternateItem?.selectedZoneId ?? 0;

    if (!performancePricing) {
        performancePricing = state.packageListing.performancePricingList.get(itemDetails.itemIdToRemove);
    }

    return {
        text: state.packageListingText,
        isFixedPackage: state.packageListingSettings.isFixed,
        itemProcessErrorMessage: perfMessage.length > 0 ? perfMessage[0].errorMessage : '',
        selectedZone: performancePricing ? performancePricing.zones
            .filter(z => z.zone.id == selectedZoneId)[0]
            : null,
        selectedSecondZone: (performancePricing && alternateItemZoneId)
            ? performancePricing.zones.filter(z => z.zone.id == alternateItemZoneId)[0]
            : null,
        isUnseated: state.packageListingSettings.useUnseatedReservation,
        itemIdToRemove: itemDetails.itemIdToRemove,
        itemDateString: itemDetails.itemDate,
        itemTimeString: itemDetails.itemTime,
        itemFacility: itemDetails.facility.facilityDescription,
        itemTitle: itemDetails.itemTitle,
        alternateItemTitle: alternateItemDetails?.itemTitle ?? '',
        itemSeason: itemDetails.itemSeason,
        showRemoveButton: state.packageListing.packages.length !== 1,
        selectSecondZoneMessageString: state.packageListingText.selectSecondZoneMessageString,
        disableAllSeries: state.packageListing.disableAllSeriesButtons
    }
}

function mapDispatchToProps(dispatch, ownProps: CartItemProps): DispatchToProps {
    return {
        removeItem: (itemId: number, isAlternate?: boolean) => {
            dispatch(removeItemFromCart(itemId, isAlternate ?? false));
        },
        removeZone: (itemId: number) => {
            dispatch(removeSelectedZone(itemId));
        },
        toggleAlternateRequestType: (itemId: number) => {
            dispatch(toggleAlternateRequestType(itemId));
        },
        disablePerfButtons: (isDisabled?: boolean) => {
            dispatch(disablePerformanceButtons(isDisabled ?? false))
        }
        
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(FiltersBase);